module.exports = __webpack_public_path__ + "img/1-3.fa4b3d78.png";